"use client"
import React, { useState } from 'react'
import { IoCall } from "react-icons/io5";
import { CiMail } from "react-icons/ci";
import Link from 'next/link';
import { FiPaperclip } from "react-icons/fi";
import { BASE_URL } from '@/utils/api';
import Cookies from 'js-cookie';
import axios from 'axios';
import toast from 'react-hot-toast';
import { json } from 'stream/consumers';
import { useRouter } from 'next/navigation';
const Support = () => {
  const router = useRouter()
  const [data, setData] = useState({ name: '', email: '', subject: '', message: '', phone_number: '' });
  const [errors, setErrors] = useState({ name: '', email: '', subject: '', message: '', phone_number: '' });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]{10}$/; // Adjust according to your requirements
  const validateForm = () => {
    let formErrors = { name: '', email: '', subject: '', message: '', phone_number: '' };
    let isValid = true;
    if (!data.name) {
      formErrors.name = 'Full name is required.';
      isValid = false;
    }
    if (!data.email) {
      formErrors.email = 'Email is required.';
      isValid = false;
    } else if (!emailRegex.test(data.email)) {
      formErrors.email = 'Enter a valid email address.';
      isValid = false;
    }
    if (!data.subject) {
      formErrors.subject = 'Subject is required.';
      isValid = false;
    }
    if (!data.phone_number) {
      formErrors.phone_number = 'Phone number is required.';
      isValid = false;
    } else if (!phoneRegex.test(data.phone_number)) {
      formErrors.phone_number = 'Enter a valid phone number (10 digits).';
      isValid = false;
    }
    if (!data.message) {
      formErrors.message = 'Message is required.';
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };
  const submitData = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const response = await axios.post(`${BASE_URL}contact/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success('Message sent successfully');
      setData({ name: '', email: '', subject: '', message: '', phone_number: '' });
      router.push('/thank-you')
    } catch (error: any) {
      // console.error('Error submitting data:', error);
      toast.error('Try again');
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };
  return (
    <div>
      <div className='flex flex-col  gap-5 lg:flex-row justify-between'>
        <div className='lg:w-1/2'>
          <p className='font-semibold text-[20px]  text-black'>Common Issues & Fixes</p>
          <div className='rounded-lg shadow-lg mt-5 border-[1px] border-slate-200 p-8'>
            <div className=''>
              <div className=' py-3  border-b-[1px] border-slate-200'>
                <p className='text-[17px] font-medium'>1. Unable to Sign Up  </p>
                <p className='text-[16px] text-textGrey'>If you are facing issues with registration, please check the following</p>
                <ul className='text-textGrey px-6 list-disc'>
                  <li>
                    Ensure
                    you have entered a valid email and password.
                  </li>
                  <li>Check
                    your spam/junk folder for the verification email.
                  </li>
                  <li>If
                    the issue persists, try using a different browser or clearing your cache.
                  </li>
                  <li>
                    Still need help? Contact our support team at<Link href="mailto:academy@w3era.com">
                      <span className="text-orange hover:cursor-pointer"> academy@w3era.com</span>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className=' py-3  border-b-[1px] border-slate-200'>
                <p className='text-[17px] font-medium'>2. Forgot Password / Unable to Login  </p>
                <p className='text-[16px] text-textGrey'>Forgot your password? No worries! Click on ‘Forgot Password’ on the login
                  page and follow the instructions to reset it.</p>
                <ul className='text-textGrey px-6 list-disc'>
                  <li>
                    Make
                    sure you are entering the correct email
                  </li>
                  <li>If
                    you haven’t received the password reset email, check your spam folder.
                  </li>
                  <li>If
                    the issue persists, try using a different browser or clearing your cache.
                  </li>
                  <li>
                    If you are still unable to log in, reach out to us at
                    <Link href="mailto:academy@w3era.com">
                      <span className="text-orange hover:cursor-pointer"> academy@w3era.com</span>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className=' py-3  border-b-[1px] border-slate-200'>
                <p className='text-[17px] font-medium'>3. Lessons Marked as Incomplete  </p>
                <p className='text-[16px] text-textGrey'>If your course progress is not saving</p>
                <ul className='text-textGrey px-6 list-disc'>
                  <li>
                    Ensure
                    you are logged in while taking the course.
                  </li>
                  <li>Try
                    using a different browser or clearing cache.
                  </li>
                  <li>
                    If your course progress is still not being tracked, please reach out to us at
                    <Link href="mailto:academy@w3era.com">
                      <span className="text-orange hover:cursor-pointer"> academy@w3era.com</span>
                    </Link>.
                  </li>
                </ul>
              </div>
              
            </div>
          </div>
        </div>
        <div className='lg:w-1/2'>
          <div className=' '>
            <p className='text-[20px] mb-4 font-semibold text-black'>Contact Us</p>
            <div className='border-[1px] px-4 lg:px-8 py-8 border-slate-200 flex justify-between gap-7 shadow-lg rounded-lg'>
              <div className='flex flex-wrap  justify-between'>
                <div className=' w-full sm:w-[48%]'>
                  <label className='text-[17px] font-medium text-black'>Full Name</label>
                  <br />
                  <input
                    type="text"
                    name='name'
                    className='capitalize text-textGrey mt-2 w-full outline-none border-[2px] px-4 py-2 border-slate-200 rounded-lg'
                    required
                    placeholder='Enter your full name'
                    onChange={handleChange}
                  />
                  {errors.name && <p className='text-red-500 text-sm'>{errors.name}</p>}
                </div>
                <div className=' w-full sm:w-[48%]'>
                  <label htmlFor="email" className='text-[17px] font-medium text-black'>Email Address</label>
                  <br />
                  <input
                    type="text"
                    required
                    name='email'
                    className='capitalize mt-2 text-textGrey outline-none w-full border-[2px] px-4 py-2 border-slate-200 rounded-lg'
                    placeholder='Enter your Email'
                    onChange={handleChange}
                  />
                  {errors.email && <p className='text-red-500 text-sm'>{errors.email}</p>}
                </div>
                <div className=' w-full sm:w-[48%]'>
                  <label htmlFor="subject" className='text-[17px] font-medium text-black'>Subject</label>
                  <br />
                  <input
                    type="text"
                    name='subject'
                    className='capitalize mt-2 text-textGrey outline-none w-full border-[2px] px-4 py-2 border-slate-200 rounded-lg'
                    required
                    placeholder='Enter your Subject'
                    onChange={handleChange}
                  />
                  {errors.subject && <p className='text-red-500 text-sm'>{errors.subject}</p>}
                </div>
                <div className=' w-full sm:w-[48%]'>
                  <label className='text-[17px] font-medium text-black'>Phone Number</label>
                  <br />
                  <input
                    type="text"
                    name='phone_number'
                    className='capitalize mt-2 text-textGrey outline-none w-full border-[2px] px-4 py-2 border-slate-200 rounded-lg'
                    required
                    placeholder='Enter Your Phone no'
                    onChange={handleChange}
                  />
                  {errors.phone_number && <p className='text-red-500 text-sm'>{errors.phone_number}</p>}
                </div>
                <div className='w-full'>
                  <label htmlFor="message" className='text-[17px] font-medium text-black'>Message</label>
                  <br />
                  <textarea
                    name='message'
                    className='capitalize mt-2 text-textGrey w-full outline-none border-[2px] px-4 py-2 border-slate-200 rounded-lg'
                    required
                    placeholder='Describe your issues or questions'
                    onChange={handleChange}
                  />
                  {errors.message && <p className='text-red-500 text-sm'>{errors.message}</p>}
                </div>
                <button className='px-4 mt-4 py-2 rounded-md bg-orange text-white lg:text-[18px] font-medium' onClick={submitData}>
                  Submit Request
                </button>
              </div>
            </div>
          </div>
          <p className='font-semibold text-[20px] mt-6 text-black'>Contact Information</p>
          <div className='rounded-lg shadow-lg mt-5 border-[1px] border-slate-200 p-8'>
            <div className='flex gap-3 text-medium  items-center'>
              <div className='size-[40px] rounded-full bg-[#F24A2540] flex justify-center items-center text-textGrey'><IoCall className='text-orange text-[20px]' />
              </div>
              <div>
                Call us at <span className='text-orange'>+91-9887555600</span> for direct support
              </div>
            </div>
            <div className='flex items-start gap-3 mt-6 '>
              <div className='min-w-[40px] min-h-[40px] rounded-full bg-[#F24A2540] flex justify-center items-center text-textGrey'>
                <CiMail className='text-orange text-[22px]' />
              </div>
              <div className='text-medium'>
                Reach out to us at
                <span className='text-orange mx-[2px]'> <a href="mailto:"></a></span> for detailed inquiries. We aim to respond within 24 hours.
                <div>
                  <Link href="mailto:academy@w3era.com">
                    <button className='px-4 py-2 rounded-md bg-orange text-white text-[16px] lg:text-[18px] mt-4'>Email US</button>
                  </Link>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Support